/** Only a complete, successful Catalyst session can complete OTP login. */
export async function verifyLoginOtp(payload: {
  type: string; token: string; email?: string; phone?: string; redirect_to: string;
}) {
  const response = await fetch('https://budflow.com/catalyst/auth/verify', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await response.json();
  if (!response.ok || data.error_code || !data.access_token || !data.user?.id) {
    throw new Error(data.msg || data.message || 'OTP verification failed');
  }
  return data;
}
